var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasMultipleAvailableLocales)?_c('v-menu',{attrs:{"offset-y":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","title":_vm.$t('message.menu.locale'),"icon":""},slot:"activator"},[_c('v-icon',[_vm._v("language")])],1),_c('v-list',_vm._l((_vm.availableLocales),function(ref,index){
var code = ref.code;
var name = ref.name;
var flag = ref.flag;
return _c('v-list-tile',{key:name,class:{
        active: _vm.currentLocale === code,
        'mb-1': index !== _vm.availableLocales.length - 1,
      },on:{"click":function($event){return _vm.setLocale(code)}}},[_c('v-flex',{staticClass:"d-flex mr-3",domProps:{"innerHTML":_vm._s(flag)}}),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(name))])],1)],1)}),1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }